'use strict';

exports.__esModule = true;

var _shallowEqual = require('fbjs/lib/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/recompose/shallowEqual.js
 ** module id = 76
 ** module chunks = 0
 **/